import { gql } from "@apollo/client";
import { OrderBy } from "../queryString";
import { EnforcementActiveScofflaw, enforcementActiveScofflawFragment } from "../fragments";

export const GET_ACTIVE_SCOFFLAWS = gql`
  query GetActiveScofflaws(
    $offset: Int = 0
    $limit: Int = 100
    $filter: enforcement_active_scofflaw_bool_exp!
    $orderBy: [enforcement_active_scofflaw_order_by!]
  ) {
    activeScofflaws: enforcement_active_scofflaw(where: $filter, offset: $offset, limit: $limit, order_by: $orderBy) {
      ...enforcementActiveScofflawFragment
    }
    activeScofflawAggregate: enforcement_active_scofflaw_aggregate(where: $filter) {
      aggregate {
        count
      }
    }
  }
  ${enforcementActiveScofflawFragment}
`;

export interface GetActiveScofflawsData {
  activeScofflaws: EnforcementActiveScofflaw[];
  activeScofflawAggregate: {
    aggregate: {
      count: number;
    };
  };
}

export interface GetActiveScofflawsVars {
  offset?: number;
  limit?: number;
  filter: GetActiveScofflawsWhereFilter;
  orderBy?: ActiveScofflawsOrderBy[];
}

export interface GetActiveScofflawsWhereFilter {
  _and?: GetActiveScofflawsWhereExp[];
  _or?: GetActiveScofflawsWhereExp[];
}

export type GetActiveScofflawsWhereExp =
  | GetActiveScofflawsRegisteredVehicleWhereExp
  | GetActiveScofflawsScofflawBeginAtWhereExp;

export interface GetActiveScofflawsRegisteredVehicleWhereExp {
  registered_vehicle: { license_plate: { _eq: string; _ilike?: never } | { _eq?: never; _ilike: string } };
}

export interface GetActiveScofflawsScofflawBeginAtWhereExp {
  scofflaw_begin_at: { _eq?: Date; _gte?: Date; _lte?: Date };
}

export type ActiveScofflawsOrderBy =
  | EnforcementActiveScofflawsOrderByNumOutstandingIntents
  | EnforcementActiveScofflawsOrderByScofflawBeginAt;

export interface EnforcementActiveScofflawsOrderByNumOutstandingIntents {
  num_outstanding_intents: OrderBy;
}

export interface EnforcementActiveScofflawsOrderByScofflawBeginAt {
  scofflaw_begin_at: OrderBy;
}

export default GET_ACTIVE_SCOFFLAWS;
